(() => {
  if (window.CartGiftCollectionContext) return;

  const PROPERTY_NAME = 'properties[_gift_source_collection]';

  const getCollectionHandle = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      const match = url.pathname.match(/\/collections\/([^/]+)/i);
      return match ? decodeURIComponent(match[1]).trim() : '';
    } catch (_error) {
      return '';
    }
  };

  const sourceCollectionHandle =
    getCollectionHandle(window.location.href) || getCollectionHandle(document.referrer);

  if (sourceCollectionHandle) {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = new URL(form.action || '', window.location.origin);
      if (!/\/cart\/add(?:\.js)?$/i.test(action.pathname)) return;
      if (form.querySelector('[name="properties[_reward_gift]"]')) return;

      let input = form.querySelector(`[name="${PROPERTY_NAME}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROPERTY_NAME;
        form.appendChild(input);
      }
      input.value = sourceCollectionHandle;
    }, true);
  }

  window.CartGiftCollectionContext = Object.freeze({
    sourceCollectionHandle,
  });
})();
